// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"page__wrapper___2SoJi","header":"page__header___Cf2t5","body":"page__body___2koFQ","title":"page__title___3hqJN"};